import React from 'react';

import { styled } from '../theme';
import FlexColumn from './FlexColumn';

type Props = {};

const FormGroup = styled(FlexColumn)<Props>(({ theme }) => ({
    marginBottom: 20,
}));

export default (props: React.ComponentProps<typeof FlexColumn>) => (
    <FormGroup itemsSpacing={5} {...props} />
);
